import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";

import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "./ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { routeNames } from "@/main";
import { useModuloDeImpressao } from "./ModuloDeImpressaoComponent";
import { VerificarEtiquetaModal } from "./VerificarEtiquetaModal";
import { ThemeToggle } from "./ThemeToggle";
import { LanguageToggle } from "./LanguageToggle";

import { Cpu, Loader2, ScanLine, Signal } from "lucide-react";

export function SiteHeader() {
  const { t } = useTranslation();
  const location = useLocation();
  const {
    toggleSheetModulo,
    coletarInfoDoModulo,
    aguardandoStatusModulo,
    lerEtiquetaParaConferir,
    aguardandoLeituraEtiqueta,
  } = useModuloDeImpressao();

  const tituloKey = routeNames[location.pathname];
  const titulo = tituloKey ? t(tituloKey) : "";

  return (
    <>
      <VerificarEtiquetaModal />
      <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
        <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
          <SidebarTrigger className="-ml-1" />
          <Separator
            orientation="vertical"
            className="mx-2 data-[orientation=vertical]:h-4"
          />
          <h1 className="text-base font-medium truncate">{titulo}</h1>

          <div className="ml-auto flex items-center gap-2 z-10">
            <TooltipProvider delayDuration={250}>
              <LanguageToggle />
              <ThemeToggle />

              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={coletarInfoDoModulo}
                    disabled={aguardandoStatusModulo}
                  >
                    {aguardandoStatusModulo ? (
                      <Loader2 className="h-4 w-4 animate-spin" />
                    ) : (
                      <Signal className="h-4 w-4" />
                    )}
                    <span className="hidden md:inline">
                      {aguardandoStatusModulo
                        ? t("common.waiting")
                        : t("header.moduleStatus")}
                    </span>
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="md:hidden">
                  {t("header.moduleStatusFull")}
                </TooltipContent>
              </Tooltip>

              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={lerEtiquetaParaConferir}
                    disabled={aguardandoLeituraEtiqueta}
                  >
                    {aguardandoLeituraEtiqueta ? (
                      <Loader2 className="h-4 w-4 animate-spin" />
                    ) : (
                      <ScanLine className="h-4 w-4" />
                    )}
                    <span className="hidden md:inline">
                      {aguardandoLeituraEtiqueta
                        ? t("common.reading")
                        : t("header.checkLabel")}
                    </span>
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="md:hidden">
                  {t("header.checkLabel")}
                </TooltipContent>
              </Tooltip>

              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => toggleSheetModulo()}
                  >
                    <Cpu className="h-4 w-4" />
                    <span className="hidden md:inline">
                      {t("header.moduleConfig")}
                    </span>
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="md:hidden">
                  {t("header.moduleConfigFull")}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        </div>
      </header>
    </>
  );
}
